export default "__VITE_ASSET__BYyy11hP__"